import { evolve, toPairs } from "ramda";

export const json = (res: Response) => res.json();

export const mapFlags = evolve<any>({ meta: { ui: { titles: toPairs } } });
